import * as React from 'react';
import { useToggleState } from 'src/commons/hooks';
import { AccountTypeFilter, CentricAccountTypeFilter } from './IA2Types';

type useAccountTypeFilterProps = {
  accountTypes: AccountTypeFilter[];
  onSubmit: (selectedFilters: AccountTypeFilter[]) => void;
};
type useCentricAccountTypeFilterProps = {
  accountTypes: CentricAccountTypeFilter[];
  onSubmit: (selectedFilters: CentricAccountTypeFilter[]) => void;
};

export const useAccountTypeFilter = ({
  accountTypes,
  onSubmit,
}: useAccountTypeFilterProps) => {
  const { isOpen, handleClose, handleOpen } = useToggleState();

  // need to re-create the objects in the array to break reference
  const [accountTypesState, setAccountTypesState] = React.useState(
    accountTypes.map((accountType) => ({ ...accountType })),
  );

  const filteredAccountTypeCount = accountTypes.filter(
    (accountTypes) => !accountTypes.isSelected,
  ).length;

  const handleSubmit = () => {
    onSubmit(accountTypesState);
    handleClose();
  };

  const generateHandleSelection =
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const newArray = [...accountTypesState];
      newArray[index].isSelected = e.target.checked;
      setAccountTypesState(newArray);
    };

  return {
    accountTypesState,
    filteredAccountTypeCount,
    isOpen,
    handleClose,
    handleOpen,
    handleSubmit,
    generateHandleSelection,
  };
};

export const useCentricAccountTypeFilter = ({
  accountTypes,
  onSubmit,
}: useCentricAccountTypeFilterProps) => {
  const { isOpen, handleClose, handleOpen } = useToggleState();

  // need to re-create the objects in the array to break reference
  const [accountTypesState, setAccountTypesState] = React.useState(
    accountTypes.map((accountType) => ({ ...accountType })),
  );

  const filteredAccountTypeCount = accountTypes.filter(
    (accountTypes) => !accountTypes.isSelected,
  ).length;

  const handleSubmit = () => {
    onSubmit(accountTypesState);
    handleClose();
  };

  const generateHandleSelection =
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const newArray = [...accountTypesState];
      newArray[index].isSelected = e.target.checked;
      setAccountTypesState(newArray);
    };

  return {
    accountTypesState,
    filteredAccountTypeCount,
    isOpen,
    handleClose,
    handleOpen,
    handleSubmit,
    generateHandleSelection,
  };
};
